import { render, staticRenderFns } from "./ConfigSmtp.vue?vue&type=template&id=40fdbbc2&scoped=true"
import script from "./ConfigSmtp.vue?vue&type=script&lang=js"
export * from "./ConfigSmtp.vue?vue&type=script&lang=js"
import style0 from "./ConfigSmtp.vue?vue&type=style&index=0&id=40fdbbc2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40fdbbc2",
  null
  
)

export default component.exports